import loadable from '@loadable/component'
import {RouteConfig} from 'react-router-config'

export default [
  {
    path: '/lord',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-lord-home" */ '~/pages/lord/pages/home'
        )
    ),
  },
  {
    path: '/lord/my',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-lord-my" */ '~/pages/lord/pages/my')
    ),
  },
  {
    path: '/lord/rule',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-lord-rule" */ '~/pages/lord/pages/rule'
        )
    ),
  },
] as RouteConfig[]
